// extracted by mini-css-extract-plugin
module.exports = {"card":"CardGrid_card__32cel","overlay":"CardGrid_overlay__6treq","content":"CardGrid_content__U4Y_F","gradient-overlay":"CardGrid_gradient-overlay__WlGWB"};